import { getNetworkByChainId } from '@dapp/multi-lib/network';
import { appConfig } from 'utils/app.config';

export function addUrlArgument(
  url: string,
  paramName: string,
  paramValue: string
): string {
  const urlObj = new URL(url);
  urlObj.searchParams.append(paramName, paramValue);
  return urlObj.toString();
}

export function getTokenIconUrl(tokenSymbol: string) {
  return `${appConfig.staticAssetsHost}/sfi/icons/tokens/${tokenSymbol}.svg`;
}

export function getStaticAssetUrl(path: string) {
  return `${appConfig.staticAssetsHost}${path}`;
}

export function getNetworkIconUrlByChaiId(chainId: number) {
  const network = getNetworkByChainId(chainId);

  if (!network) {
    return '';
  }

  return `${appConfig.staticAssetsHost}/sfi${network.iconUrl}` || '';
}
